// extracted by mini-css-extract-plugin
module.exports = {"specialists":"Ic9qI","specialists_header":"eMDMA","specialists_table":"fzG2a","no-data":"M2Ea4","specialists_table_total":"jCmBY"};